import script from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"

import "./RegisterUser.vue?vue&type=style&index=0&id=ae740c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae740c00"]])

export default __exports__